import { gql } from '@apollo/client';
import { insuranceFragment, hotelFragment } from 'store/fragments';
import { booking, leg, product, passenger } from '../queries/GET_BOOKING';

export default gql`
  mutation voidBooking($bookingReference: String!, $cancellationReason: String) {
    voidBooking(bookingReference: $bookingReference, cancellationReason: $cancellationReason) {
      ${booking}
    }
  }

  ${insuranceFragment}

  ${hotelFragment}

  ${leg}

  ${passenger}

  ${product}
`;
